import truncate from "lodash/truncate"
import get from "lodash/get"
import { Component } from "react"
import PropTypes from "prop-types"
import getContentUrl from "utils-lib/getContentUrl"
import getAlertVersion from "utils-lib/alerts"
import Typography from "component-lib/Base/components/Typography"
import { Link } from "../../../../../Base"
import "./MajorAlert.scss"

const ALERT_VERSION = getAlertVersion()
const LOCAL_STORAGE_KEY = `${ALERT_VERSION}-alreadyVisited`

class MajorAlert extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isVisible: true,
    }
  }

  isNotificationHidden = (title) => {
    const visitedAlerts = localStorage.getItem(LOCAL_STORAGE_KEY)

    let parseVisitedAlerts = {}
    if (visitedAlerts) {
      try {
        parseVisitedAlerts = JSON.parse(visitedAlerts)

        const hasAlertBeenSeen = get(parseVisitedAlerts, title, false)

        if (hasAlertBeenSeen) {
          return true
        }
      } catch {
        /* do nothing, use default parseVisitedAlerts value */
      }
      return false
    }
    return false
  }

  render() {
    if (this.props.majorAlerts) {
      const { carouselSection, moreDismissSection, viewAll, showMore } =
        this.props

      const { title, linktext, href, subtext } = this.props.majorAlerts

      return this.state.isVisible && !this.isNotificationHidden(title) ? (
        <div
          className="MajorAlert maax-font-weight-regular"
          style={{
            background: "#023625",
          }}
          data-testid="MajorAlert"
        >
          {/* DESKTOP WIDTH */}
          <div className="d-none d-lg-block position-relative">
            <div className="container">
              <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center">
                  <img
                    src={getContentUrl(
                      `/content/dam/wm/icons/exclamation-circle-white.png`,
                    )}
                    style={{
                      height: 18,
                      width: 18,
                    }}
                  />
                  <Typography
                    className="title maax-font-weight-italic px-3 d-flex w-auto align-items-center"
                    style={{ color: "#fff", lineHeight: "1.68rem" }}
                    variant="h5"
                    data-testid="major-alert-title"
                  >
                    {title}
                  </Typography>

                  {!viewAll && (
                    <span
                      style={{
                        maxWidth: 680,
                      }}
                      className="wm-font-size-sm"
                    >
                      {!viewAll &&
                        !showMore &&
                        truncate(subtext, {
                          length: 80,
                        })}
                    </span>
                  )}
                  <div className="ml-3 pe-auto">{moreDismissSection}</div>
                </div>
                <div className="d-flex align-items-center">
                  {carouselSection}
                </div>
              </div>
              {(viewAll || showMore) && (
                <div
                  style={{
                    marginLeft: 34,
                  }}
                >
                  <div data-testid="major-alert-subtext">{subtext}</div>
                  {linktext && href && (
                    <Link
                      overrideClass="d-flex align-items-center linkText wm-text-yellow mr-3"
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      isExternalLink
                      analytics_key={`${title} ${linktext}`}
                    >
                      {linktext}
                    </Link>
                  )}
                </div>
              )}
            </div>
          </div>
          {/* TABLET WIDTH */}
          <div className="d-none d-md-block d-lg-none position-relative">
            <div className="container">
              <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center">
                  <img
                    src={getContentUrl(
                      `/content/dam/wm/icons/exclamation-circle-white.png`,
                    )}
                    style={{
                      height: 18,
                      width: 18,
                    }}
                  />
                  <div
                    className="title maax-font-weight-bold px-3 d-flex w-auto align-items-center"
                    style={{
                      fontSize: 18,
                    }}
                  >
                    {title}
                  </div>
                  <div className="ml-3 pe-auto">{moreDismissSection}</div>
                </div>
                <div className="d-flex align-items-center">
                  {carouselSection}
                  {/* {linktext && href && (
                  <Link
                    overrideClass="d-flex align-items-center linkText wm-text-yellow mr-3"
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    isExternalLink
                    analytics_key={`${title} ${linktext}`}
                  >
                    {linktext}
                  </Link>
                )} */}
                </div>
              </div>
              <span
                style={{
                  position: `relative`,
                  left: 34,
                }}
                className="wm-font-size-sm"
              >
                {viewAll || showMore
                  ? subtext
                  : truncate(subtext, {
                      length: 80,
                    })}
              </span>
              {(viewAll || showMore) && (
                <div
                  style={{
                    marginLeft: 34,
                  }}
                >
                  {linktext && href && (
                    <Link
                      overrideClass="d-flex align-items-center linkText wm-text-yellow mr-3"
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      isExternalLink
                      analytics_key={`${title} ${linktext}`}
                    >
                      {linktext}
                    </Link>
                  )}
                </div>
              )}
            </div>
          </div>
          {/* MOBILE WIDTH */}
          <div className="d-flex d-md-none">
            <div className="container position-relative">
              <div className=" d-flex align-items-center d-md-none justify-content-between">
                <div className="d-flex align-items-center">
                  <img
                    src={getContentUrl(
                      `/content/dam/wm/icons/exclamation-circle-white.png`,
                    )}
                    style={{
                      height: 18,
                      width: 18,
                    }}
                  />
                  <span
                    className="ml-2 title maax-font-weight-bold d-inline-block mr-3"
                    style={{
                      fontSize: 18,
                    }}
                  >
                    {title}
                  </span>
                </div>
              </div>
              <div
                className="content-container pe-auto"
                style={{
                  marginLeft: 26,
                }}
              >
                <span className="wm-font-size-sm">
                  {viewAll || showMore
                    ? subtext
                    : truncate(subtext, {
                        length: 80,
                      })}
                </span>
                {(viewAll || showMore) && (
                  <div>
                    {linktext && href && (
                      <Link
                        overrideClass="d-flex align-items-center linkText wm-text-yellow mr-3"
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        isExternalLink
                        analytics_key={`${title} ${linktext}`}
                      >
                        {linktext}
                      </Link>
                    )}
                  </div>
                )}
                {moreDismissSection}
              </div>
              {!viewAll && <div className="ml-2">{carouselSection}</div>}
            </div>
          </div>
        </div>
      ) : null
    }
    return null
  }
}

MajorAlert.propTypes = {
  majorAlerts: PropTypes.shape({
    title: PropTypes.string,
    linktext: PropTypes.string,
    href: PropTypes.string,
    subtext: PropTypes.string,
  }).isRequired,
  carouselSection: PropTypes.node,
  moreDismissSection: PropTypes.node,
  viewAll: PropTypes.bool,
  showMore: PropTypes.bool,
}

MajorAlert.defaultProps = {
  carouselSection: null,
  moreDismissSection: null,
  viewAll: false,
  showMore: false,
}

export default MajorAlert
